// =========================
// 0. BLOKADA DOMYŚLNEGO SKOKU DO KOTWICY
// =========================
//
// UWAGA:
// Samo scrollTo(0,0) na starcie nie wystarczy — przeglądarka
// potrafi doskoczyć do kotwicy ponownie (np. przy 'load' albo
// gdy zmieni się wysokość strony).
//
// Dlatego hash jest obsługiwany przez własny mechanizm scrollowania.
// =========================

document.addEventListener('DOMContentLoaded', function () {

  // =========================
  // 1. FAST SCROLL (jump)
  // =========================

  function jumpTo(y) {
    window.scrollTo(0, y);
  }


  // =========================
  // 2. SMOOTH FINISH SCROLL
  // =========================

  function smoothScrollTo(y, duration = 350) {

    const start = window.scrollY;
    const diff = y - start;

    let startTime = null;

    const easeOutCubic = t => 1 - Math.pow(1 - t, 3);

    function step(timestamp) {

      if (!startTime) {
        startTime = timestamp;
      }

      const time = timestamp - startTime;
      const progress = Math.min(time / duration, 1);

      const eased = easeOutCubic(progress);

      window.scrollTo(
        0,
        start + diff * eased
      );

      if (time < duration) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }


  // =========================
  // TOPBAR HEIGHT
  // =========================
  //
  // >= 1340px → 0
  // < 1340px  → rzeczywista wysokość topbara
  // =========================

  function getTopbarHeight() {

    const topbar = document.querySelector('#topbar');

    if (window.matchMedia('(min-width: 1340px)').matches) {
      return 0;
    }

    return topbar ? topbar.offsetHeight : 0;
  }


  // =========================
  // RUN SCROLL (2-step UX)
  // =========================

  window.runScroll = function (el, offset = 0) {

    const targetEl = document.querySelector(el);

    if (!targetEl) {
      return;
    }

    const topbarHeight = getTopbarHeight();

    const targetTop =
      targetEl.getBoundingClientRect().top +
      window.scrollY;

    const finalPosition =
      targetTop -
      topbarHeight -
      offset;

    const current = window.scrollY;

    const isNear =
      Math.abs(current - finalPosition) < 10;

    // Jeśli już jesteś na miejscu → nie rób nic
    if (isNear) {
      return;
    }

    // Pierwszy szybki skok
    const jumpPosition = finalPosition - 120;

    window.scrollTo(
      0,
      jumpPosition
    );

    // Następnie płynne dojechanie
    requestAnimationFrame(() => {

      requestAnimationFrame(() => {

        smoothScrollTo(
          finalPosition,
          450
        );

      });

    });

  };


  // =========================
  // CLICK HANDLER
  // =========================

  const gtt = document.querySelectorAll(
    "[href^='#'], [data-target]"
  );

  if (gtt.length) {

    const action = function (e) {

      const target =
        e.currentTarget.dataset.target ||
        e.currentTarget.getAttribute('href');

      if (!target || target === '#') {
        return;
      }

      const offset =
        parseInt(
          e.currentTarget.dataset.offset || 0,
          10
        );

      const mode =
        e.currentTarget.dataset.scroll || 'fast';

      const exists =
        document.querySelector(target);

      if (exists) {

        e.preventDefault();

        switch (mode) {

          // =========================
          // FAST
          // =========================
          //
          // Skok + płynne dojechanie
          // =========================

          case 'fast':

            window.runScroll(
              target,
              offset
            );

            break;


          // =========================
          // SMOOTH
          // =========================
          //
          // Bez początkowego skoku
          // =========================

          case 'smooth': {

            const topbarHeight =
              getTopbarHeight();

            const finalPosition =
              exists.getBoundingClientRect().top +
              window.scrollY -
              topbarHeight -
              offset;

            smoothScrollTo(
              finalPosition,
              450
            );

            break;
          }


          // =========================
          // NATIVE
          // =========================

          case 'native':

            exists.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });

            break;


          // =========================
          // DEFAULT
          // =========================

          case 'default':

            return;


          // =========================
          // FALLBACK
          // =========================

          default:

            window.runScroll(
              target,
              offset
            );

        }

      } else {

        // Jeśli element nie istnieje na aktualnej stronie,
        // przechodzimy na stronę główną z odpowiednim hashem.

        e.preventDefault();

        window.location.href =
          window.location.origin +
          '/' +
          target;

      }

    };


    gtt.forEach(el => {
      el.addEventListener(
        'click',
        action
      );
    });

  }


  // =========================
  // OBSŁUGA KOTWICY PRZY WEJŚCIU
  // =========================
  //
  // np.
  // obszary.html#area
  // =========================

  if (window.__pendingHash) {

    const hash =
      window.__pendingHash;

    // Czekamy na pełne załadowanie:
    // obrazki, fonty itd.
    window.addEventListener(
      'load',
      function () {

        setTimeout(() => {

          window.runScroll(
            hash,
            0
          );

          // Przywracamy hash w URL
          // bez wywoływania ponownego scrolla.

          history.replaceState(
            null,
            '',
            hash
          );

        }, 50);

      }
    );

  }

});